// @flow
import React from "react";
import fileDownload from "js-file-download";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import I18n from "../i18n/I18n";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /* Post payload */

  function* postOutbound(action) {
    try {
      const response = yield call(api.transfer.postOutbound, action.transfer);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.postOutboundSuccess(response.data));
        toast(
          I18n.getText(
            "pickup.pickup-successfully",
            {},
            "Pickup Scheduled Successfully"
          ),
          {
            type: "success",
            className: "successClass"
          }
        );
      } else {
        yield put(Actions.postOutboundFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.postOutboundFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchPostOutbound(): Generator<void, void, void> {
    yield takeLatest(Types.POST_OUTBOUND, postOutbound);
  }

  /* Get transfers */
  function* getTransfers(action) {
    try {
      const response = yield call(
        api.transfer.getTransfers,
        action.query,
        action.fromnoon,
        action.fbn
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getTransfersSuccess(response.data));
      } else {
        yield put(Actions.getTransfersFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getTransfersFailure(error));
    }
  }
  function* watchGetTransfers(): Generator<void, void, void> {
    yield takeLatest(Types.GET_TRANSFERS, getTransfers);
  }

  /* Get asn */
  function* getAsn(action) {
    try {
      const response = yield call(
        api.transfer.getAsn,
        action.query,
        action.print,
        action.rtv
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getAsnSuccess(response.data));
        const params = URLSearchParams ? new URLSearchParams(action.query) : "";
        if (action.print) {
          if (
            action.query.indexOf("unidentified") === -1 &&
            action.query.indexOf("type") === -1
          ) {
            action.query = `${action.query}&type=unidentified`;
            const rtv = params && params.get("rtv_nr");
            yield put(
              Actions.getAsn(action.query, action.print, rtv ? "rtv" : null)
            );
          }
        } else if (action.query.indexOf("is_export") !== -1) {
          const asn = params && params.get("asn_nr");
          const rtv = params && params.get("rtv_nr");
          fileDownload(response.data, `${asn || rtv || "items"}.csv`);
        } else {
          const rtv = params && params.get("rtv_nr");
          yield put(Actions.getTransfersCount(action.query, rtv));
        }
      } else {
        yield put(Actions.getAsnFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getAsnFailure(error));
    }
  }
  function* watchGetAsn(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ASN, getAsn);
  }

  /* Get count */
  function* getTransfersCount(action) {
    try {
      const response = yield call(
        api.transfer.getTransfersCount,
        action.query,
        action.rtv
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getTransfersCountSuccess(response.data));
      } else {
        yield put(
          Actions.getTransfersCountFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getTransfersCountFailure(error));
    }
  }
  function* watchgetTransfersCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_TRANSFERS_COUNT, getTransfersCount);
  }

  /* getFbnTransfersCount */
  function* getFbnTransfersCount(action) {
    try {
      const response = yield call(
        api.transfer.getFbnTransfersCount,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getFbnTransfersCountSuccess(response.data));
      } else {
        yield put(
          Actions.getFbnTransfersCountFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getFbnTransfersCountFailure(error));
    }
  }
  function* watchgetFbnTransfersCount(): Generator<void, void, void> {
    yield takeLatest(Types.GET_FBN_TRANSFERS_COUNT, getFbnTransfersCount);
  }

  /* close ASN */

  function* closeAsn(action) {
    try {
      const response = yield call(api.transfer.closeAsn, action.warehouse);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.closeAsnSuccess(response.data));
        toast(I18n.getText("transfers.close-success"), {
          type: "success",
          className: "successClass"
        });
      } else {
        yield put(Actions.closeAsnFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.closeAsnFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchCloseAsn(): Generator<void, void, void> {
    yield takeLatest(Types.CLOSE_ASN, closeAsn);
  }

  /* OPEN FBN ASN */

  function* openFbnAsn(action) {
    try {
      const response = yield call(api.transfer.openFbnAsn, action.whObj);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.openFbnAsnSuccess(response.data));
      } else {
        yield put(Actions.openFbnAsnFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.openFbnAsnFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchOpenFbnAsn(): Generator<void, void, void> {
    yield takeLatest(Types.OPEN_FBN_ASN, openFbnAsn);
  }
  /* importFbnAsn  ASN */

  function* importFbnAsn(action) {
    try {
      const response = yield call(api.transfer.importFbnAsn, action.file);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.importFbnAsnSuccess(response.data));
        if (response.data.message) {
          toast(response.data.message, {
            type: "success",
            className: "successClass"
          });
        }
      } else {
        yield put(Actions.importFbnAsnFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.importFbnAsnFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchImportFbnAsn(): Generator<void, void, void> {
    yield takeLatest(Types.IMPORT_FBN_ASN, importFbnAsn);
  }

  /* scheduleAsn  ASN */

  function* scheduleAsn(action) {
    try {
      const response = yield call(api.transfer.scheduleAsn, action.obj);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.scheduleAsnSuccess(response.data));
        toast(I18n.getText("transfers.schedule-success"), {
          type: "success",
          className: "successClass"
        });
      } else {
        yield put(Actions.scheduleAsnFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.scheduleAsnFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchScheduleAsn(): Generator<void, void, void> {
    yield takeLatest(Types.SCHEDULE_ASN, scheduleAsn);
  }

  /* scheduleAsn  ASN */

  function* retrieveSlots(action) {
    try {
      const response = yield call(api.transfer.retrieveSlots, action.obj);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.retrieveSlotsSuccess(response.data));
      } else {
        yield put(Actions.retrieveSlotsFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.retrieveSlotsFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchRetrieveSlots(): Generator<void, void, void> {
    yield takeLatest(Types.RETRIEVE_SLOTS, retrieveSlots);
  }

  /* GET INITIAL LINES */

  function* getInitialLines(action) {
    try {
      const response = yield call(
        api.transfer.getInitialLines,
        action.query,
        action.typeText
      );

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getInitialLinesSuccess(response.data));
        // fileDownload(response.data, `item.csv`);
      } else {
        yield put(
          Actions.getInitialLinesFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getInitialLinesFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetInitialLines(): Generator<void, void, void> {
    yield takeLatest(Types.GET_INITIAL_LINES, getInitialLines);
  }

  /* GET PROCESSED LINES */

  function* getProcessedLines(action) {
    try {
      const response = yield call(
        api.transfer.getProcessedLines,
        action.query,
        action.scheduled
      );

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        const params = new URLSearchParams(action.query);
        if (action.query.indexOf("is_export") !== -1) {
          const asn = params.get("asn_nr");
          fileDownload(response.data, `${asn || "items"}.csv`);
          yield put(Actions.getProcessedLinesSuccess());
        } else yield put(Actions.getProcessedLinesSuccess(response.data));
        yield put(Actions.getFbnTransfersCount(action.query));
      } else {
        yield put(
          Actions.getProcessedLinesFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getProcessedLinesFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetProcessedLines(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PROCESSED_LINES, getProcessedLines);
  }

  /* GET PROCESSED LINES */

  function* getAsnBatches(action) {
    try {
      const response = yield call(api.transfer.getAsnBatches, action.query);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getAsnBatchesSuccess(response.data));
      } else {
        yield put(Actions.getAsnBatchesFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getAsnBatchesFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchGetAsnBatches(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ASN_BATCHES, getAsnBatches);
  }

  /* EXPORT ELIGIBLE */

  function* exportEligibleOffers(action) {
    try {
      const response = yield call(api.transfer.exportEligibleOffers);

      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.exportEligibleOffersSuccess());
        fileDownload(response.data, `item.csv`);
      } else {
        yield put(
          Actions.exportEligibleOffersFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportEligibleOffersFailure(error));
      toast(error, {
        type: "error",
        className: "errorClass"
      });
    }
  }
  function* watchExportEligibleOffers(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_ELIGIBLE_OFFERS, exportEligibleOffers);
  }

  /* GET STATUS */

  function* getStatus(action) {
    try {
      const response = yield call(api.transfer.getStatus);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getStatusSuccess(response.data));
      } else {
        yield put(
          Actions.getStatusFailure(response.data.error || "Error")
        );
      }
    } catch (error) {
      yield put(Actions.getStatusFailure(error));
    }
  }
  function* watchGetStatus(): Generator<void, void, void> {
    yield takeLatest(Types.GET_STATUS, getStatus);
  }

  /* GET RTV STATUS */

  function* getRtvStatuses(action) {
    try {
      const response = yield call(api.transfer.getRtvStatuses);
      if (response.ok && {}.hasOwnProperty.call(response, "data")) {
        yield put(Actions.getRtvStatusesSuccess(response.data));
      } else {
        yield put(
          Actions.getRtvStatusesFailure(response.data.error || "Error")
        );
      }
    } catch (error) {
      yield put(Actions.getRtvStatusesFailure(error));
    }
  }
  function* watchGetRtvStatuses(): Generator<void, void, void> {
    yield takeLatest(Types.GET_RTV_STATUS, getRtvStatuses);
  }

  return {
    watchPostOutbound,
    watchGetTransfers,
    watchGetAsn,
    watchgetTransfersCount,
    watchgetFbnTransfersCount,
    watchCloseAsn,
    watchOpenFbnAsn,
    watchGetInitialLines,
    watchImportFbnAsn,
    watchScheduleAsn,
    watchExportEligibleOffers,
    watchGetProcessedLines,
    watchGetAsnBatches,
    watchRetrieveSlots,
    watchGetStatus,
    watchGetRtvStatuses
  };
};



// WEBPACK FOOTER //
// ./src/sagas/TransferSaga.js